<template>
  <div class="communication-tab" :id="id">
    <AuthDialog
      v-if="visibleAuthForm"
      :is_visible="visibleAuthForm"
      :module="telegramModule"
      :session-id="sessionId"
      :user-id="userId"
      @close-popup="visibleAuthForm = false"
    />
    <div class="communications" v-loading="visibleLoader">
      <div
        ref="messages"
        v-if="communications.length"
        :class="['messages', visibleScrollbar ? 'messages--scrollable' : '']"
        @scroll="handleScroll"
      >
        <Message
          v-for="msg in communications"
          ref="message"
          :key="msg.id"
          :msg="msg"
          :id="id"
          :name="name"
          :emails="emails"
        ></Message>
      </div>
      <div v-else class="empty">
        Список сообщений пуст. <br />
        Вы можете отправить кандидату первое сообщение
      </div>
    </div>
    <form
      :id="`msg-form-${id}`"
      enctype="multipart/form-data"
      class="communications-control"
    >
      <div v-if="uploaded_files.length" class="upload-list shadow-lvl-3 brs-4">
        <DocumentRow
          v-for="(file, i) in uploaded_files"
          :key="file.uid"
          :document="file"
          :index="i"
          :details-text="Number(file.size / 1024 / 1024).toFixed(2) + ' Мб'"
          :document-name="file.name"
          :allow-remove="true"
          :visible-delete-icon="true"
          @delete-file="deleteFile"
        />
      </div>
      <div v-else class="communications-control__btns">
        <div class="communication-inputbox">
          <div class="message-area">
            <button
              v-if="!allowCreateMessage"
              v-loading="btnVisibleLoader"
              type="button"
              @click="initMessengerMode"
              @mouseenter="dialogBtnHovered = true"
              @mouseleave="dialogBtnHovered = false"
              :class="[
                params.hasTelegram ? 'start-dialog-btn' : 'check-dialog-btn',
                'fw-500'
              ]"
            >
              <template v-if="params.hasTelegram">
                <blocked-icon :unblocked="dialogBtnHovered"></blocked-icon>
                Нажмите, чтобы начать диалог
              </template>
              <template v-else>
                <Icon iconName="info" />
                Нажмите, чтобы проверить канал
              </template>
            </button>
            <div v-else class="message-area__input" v-loading="templateLoader">
              <div>
                <Dropdown
                  size="big"
                  disabled
                  :options="newOptions"
                  :field="{
                    name: 'template',
                    type: 'relate',
                    placeholder: 'Выберите шаблон'
                  }"
                  :model="model"
                  :visibleLoadMoreBtn="loadMoreNum == 50"
                  @load-more="(str, method) => setNewOptions(str, method)"
                  @filter-option="(str, method) => filterOptions(str, method)"
                  @set-value="(name, value) => handleCommand(value)"
                />

                <Tooltip
                  content="Создать шаблон"
                  placement="top-start"
                  :disabled="!accessToCreateTemplate"
                >
                  <div style="width: 48px; min-width: 48px">
                    <Button
                      v-if="accessToCreateTemplate"
                      buttonColor="white"
                      buttonText=""
                      buttonSize="big"
                      hasLeftIcon
                      class="template-button"
                      iconName="Plus"
                      @click="createTemplate"
                    />
                  </div>
                </Tooltip>
              </div>
              <div>
                <Editor
                  ref="newMsg"
                  name="mess"
                  :value="newMessage"
                  placeholder="Сообщение"
                  :max-length="10000"
                  @change="changeText"
                  :showLength="false"
                  :whiteResizeIcon="false"
                  @keydown.native.enter.exact="sendMsg($event)"
                  class="message-area__textarea"
                />
                <Button
                  :disabled="!newMessage.trim()"
                  buttonColor="blue"
                  buttonText=""
                  buttonSize="big"
                  hasLeftIcon
                  iconName="Send"
                  @click="sendMsg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { store } from '@/store';
import { mixin, errorMsg } from '@/utils/mixins';
import { getController, postController } from '@/controllers/request.js';
import {
  ACTION,
  SUBPANEL,
  FIELD,
  MODULE,
  BUTTON,
  SORT_PARAMS,
  SORT_ORDER
} from '@/utils/constants';
import Message from 'Elements/Messenger/Message';
import Button from 'Elements/Button/Button';
import BlockedIcon from 'Elements/SVG/BlockedIcon';
import Icon from 'Elements/Icon/Icon';
import AuthDialog from 'Elements/Dialog/AuthTelegramDialog';
import DocumentRow from 'Elements/Document/DocumentRow';
import Editor from 'Elements/Editor/Editor';
import Dropdown from 'Elements/Select/Dropdown';
import Tooltip from 'Elements/Tooltip/Tooltip';

export default {
  mixins: [mixin, errorMsg],
  props: {
    module: String,
    id: String,
    tab: Object,
    tableSql: String,
    userId: String,
    name: String,
    emails: {
      type: Array,
      default: () => []
    },
    allowedScroll: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default() {
        return {
          hasTelegram: Boolean,
          messagesCount: Number,
          lastEmailId: {
            type: [Number, String],
            default: 0
          },
          telegram: {
            type: String,
            default: ''
          }
        };
      }
    }
  },
  data() {
    return {
      telegramModule: MODULE.HRPAC_TELEGRAM_MESSAGES,
      SORT_PARAMS,
      no_profile_photo: '/front/public/style/img/avatar.jpg',
      formParams: {
        [SORT_PARAMS.SORT_ORDER]: SORT_ORDER.DESC,
        [SORT_PARAMS.CANDIDATES_EMAILS_CELL_ORDER_BY]: FIELD.ID.DATE_ENTERED,
        [SORT_PARAMS.CANDIDATES_EMAILS_CELL_OFFSET]: 0
      },

      endPage: false,
      communications: [],
      allowCreateMessage: false,
      dialogBtnHovered: false,
      newMessage: '',
      lastTelegramMsgID: 0,
      lastEmailMsgID: this.params.lastEmailId,
      visibleLoader: false,
      btnVisibleLoader: false,
      visibleScrollbar: false,
      visibleAuthForm: false,
      sessionId: '',
      uploaded_files: [],
      urlCreateTemplate: '',
      accessToCreateTemplate: false,
      templateLoader: false,
      newOptions: [],
      checkOptions: [],
      template: '',
      loadMoreNum: 0,
      fieldValue: [],
      model: '',
      subscriber: null
    };
  },
  created() {
    this.getCommunications();
    this.getTemplates();
  },
  computed: {
    noEmailSettings() {
      return store.state.common.notifications.send_mail;
    },
    notAccess() {
      return (
        store.state.candidate.metaData &&
        store.state.candidate.metaData.buttons_menu.some(row =>
          row.some(
            btn => btn.id == BUTTON.ID.SEND_MAIL && btn.visibility == 'disabled'
          )
        )
      );
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    },
    auth() {
      return store.state.auth.auth;
    }
  },
  methods: {
    // emailIsNull(val) {
    //   return !val || val === 'null';
    // },
    filterOptions(search_string, cb) {
      this.fieldValue = [];
      if (this.model && this.model.length) {
        if (
          this.newOptions?.length &&
          this.newOptions.find(
            option => option && option.name && option.name === this.model
          )
        ) {
          this.fieldValue.push(
            this.newOptions.find(
              option => option && option.name && option.name === this.model
            )
          );
        }
      }

      this.newOptions = [];
      this.newOptions = this.fieldValue;
      this.setNewOptions(search_string, cb);
    },
    async setNewOptions(search_string = '') {
      const iteration =
        this.newOptions.length <= 0
          ? 0
          : this.newOptions.length - this.fieldValue.length;

      const response = await getController({
        params: {
          module: 'HRPAC_TELEGRAM_MESSAGES',
          action: 'get_telegram_templates',
          limit: 50,
          offset: iteration || 0,
          search_string: search_string.trim()
        }
      });

      if (!response) return;

      const data = response?.data?.data?.templates;

      this.loadMoreNum = 0;
      this.checkOptions = [];
      let keyOptions = [];

      if (this.fieldValue && this.fieldValue.length) {
        keyOptions = this.fieldValue.map(val => {
          val.id;
        });
      }

      if (Array.isArray(data) && !data.length) {
        this.newOptions = [];
      } else {
        for (let key in data) {
          this.loadMoreNum++;

          if (typeof data[key] == 'object') {
            if (
              keyOptions.indexOf(data[key].id) == -1 &&
              this.newOptions &&
              (!this.newOptions.find(
                opt =>
                  opt &&
                  opt.id &&
                  opt.name &&
                  opt.id == data[key].id &&
                  opt.name == this.formatHtml(data[key].name)
              ) ||
                !this.newOptions.length)
            ) {
              const params = {
                ...data[key],
                id: data[key].id,
                name: this.formatHtml(data[key].name)
              };

              if (data[key].sub_text) {
                params.sub_text = this.formatHtml(data[key].sub_text);
              }

              this.checkOptions = [...this.checkOptions, params];
            }
          } else if (typeof data[key] == 'string') {
            const value = this.formatHtml(data[key]);

            if (
              keyOptions.indexOf(key) == -1 &&
              this.newOptions &&
              (!this.newOptions.find(
                opt =>
                  opt &&
                  opt.id &&
                  opt.name &&
                  opt.id == key &&
                  opt.name == value
              ) ||
                !this.newOptions.length)
            ) {
              this.checkOptions = [
                ...this.checkOptions,
                { id: key, name: value }
              ];
            }
          }
        }
      }

      this.newOptions = [...this.newOptions, ...this.checkOptions];

      return this.newOptions;
    },
    changeText(b) {
      this.newMessage = b;
    },
    updateTab(count) {
      if (!this.params.messagesCount) {
        this.$emit('set-tab-name', this.tab, { count });
      }
    },
    async handleCommand(arg) {
      let value = this.newOptions.find(
        option => option && option.name && option.name === arg
      );

      this.model = arg || '';
      if (value?.id) {
        this.templateLoader = true;
        const formData = new FormData();

        formData.set('parent_type', 'HRPAC_CANDIDATES');
        formData.set('parent_id', this.id || '');

        try {
          const resp = await postController({
            url: `/index.php?entryPoint=emailTemplateData&emailTemplateId=${value?.id}&to_pdf=true`,
            options: formData
          });

          const { data, error } = resp.data;

          if (error) {
            this.showErrorMessage(error);
            return;
          }

          if (data.multiple_values) {
            this.showNotification({
              offset: 100,
              showClose: true,
              message: `Для некоторых переменных найдено несколько значений. Оставьте нужные варианты`,
              duration: 10000,
              type: 'warning'
            });
          }

          if (!data || !data.field_mapping) return;

          for (let key in data.field_mapping) {
            if (key == 'body_from_html' && data[key]) {
              this.newMessage = '';
              this.newMessage = this.formatHtml(data[key]);
            }
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка выбора шаблона письма',
            'select email template'
          );
        } finally {
          this.templateLoader = false;
        }
      }
    },
    createTemplate() {
      if (this.urlCreateTemplate) {
        window.open(this.urlCreateTemplate, '_blank');
      }
    },
    async getTemplates() {
      try {
        const resp = await getController({
          params: {
            module: 'HRPAC_TELEGRAM_MESSAGES',
            action: 'get_telegram_templates'
          }
        });

        if (
          resp?.data?.data &&
          resp?.data?.status &&
          resp?.data?.status == 'ok'
        ) {
          this.accessToCreateTemplate =
            resp.data.data.accessToCreateTemplate || false;

          this.urlCreateTemplate = resp.data.data.urlCreateTemplate || '';
        }
      } catch (err) {
        console.error('err', err);
      }
    },
    getCommunications() {
      this.visibleLoader = true;
      getController({
        params: {
          module: this.module,
          subpanel: this.tableSql || SUBPANEL.EMAILS,
          action: ACTION.SUBPANEL_JSON_DATA,
          record: this.id,
          inline: 1,
          to_pdf: true,
          ...this.formParams
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (resp.data && !errors) {
            const { PAGINATION, ROWS } = resp.data;

            if (PAGINATION.offsets.next !== -1) {
              this.$set(
                this.formParams,
                SORT_PARAMS.CANDIDATES_EMAILS_CELL_OFFSET,
                PAGINATION.offsets.next
              );
            } else {
              this.endPage = true;
            }

            const newMsgs = ROWS.slice().reverse();
            this.communications = [...newMsgs, ...this.communications];

            if (ROWS.length) {
              const startIteration = PAGINATION.offsets.current == 0;
              this.scrollMsgToBottom(!startIteration ? ROWS[0].id : null);
              this.updateTab(ROWS.length);
            }
          }

          if (errors) {
            this.showErrorMessage(errors);
          }
        })
        .catch(err => {
          this.catchError(
            err,
            err || 'Возникла ошибка загрузки списка коммуникаций',
            'communications loading'
          );
        })
        .finally(() => {
          this.visibleLoader = false;
          this.updateEmails();
        });
    },
    checkTelegramAccount() {
      // this.contactChecked = true;
      getController({
        params: {
          module: 'Communications',
          action: 'check_communication',
          candidate_id: this.id,
          type: 'telegram'
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (resp.data && resp.data.communication) {
            this.allowCreateMessage = true;
          }
          if (errors) {
            this.showErrorMessage(errors);
          }

          if (!resp.data.communication && resp.data.result) {
            this.showNotification({
              showClose: true,
              message:
                'Кандидат еще не зарегистрирован в Телеграм. Попробуйте другой канал связи.',
              type: 'warning'
            });
          } else if (!resp.data.communication && !resp.data.result) {
            this.showNotification({
              showClose: true,
              message: 'Возникла ошибка при проверке наличия аккаунта телеграм',
              type: 'error'
            });
          }
        })
        .catch(err =>
          this.catchError(
            err,
            err || 'Возникла ошибка при проверке наличия аккаунта телеграм',
            'telegram check'
          )
        )
        .finally(() => (this.btnVisibleLoader = false));
    },
    initMessengerMode() {
      this.btnVisibleLoader = true;
      if (!this.params.hasTelegram) {
        this.checkTelegramAccount();
        return;
      }

      // получение переписки и инициализация общения
      const action = 'init_telegram_session';
      getController({
        params: {
          module: this.telegramModule,
          action,
          user_id: this.userId,
          candidate_id: this.id,
          to_pdf: true
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (!errors) {
            this.processMessageData(resp, action);

            if (resp.data.result) {
              this.allowCreateMessage = true;
            }
          } else {
            this.showErrorMessage(errors);
          }
        })
        .catch(err =>
          this.catchError(
            err,
            err || 'Возникла ошибка при получении списка коммуникаций',
            'communications load'
          )
        )
        .finally(() => (this.btnVisibleLoader = false));
    },
    processMessageData(resp, action) {
      if (!resp.data || !resp.data.result) return;

      if (action == 'check_new_emails') {
        this.communications = [...this.communications, ...resp.data.result];
        this.lastEmailMsgID = resp.data.result[0].id;

        if (!this.params.messagesCount) this.updateTab(resp.data.result.length);
        this.scrollMsgToBottom();
      } else {
        const msgsCount = resp.data.messages.length;
        this.communications = [...this.communications, ...resp.data.messages];

        if (action == 'init_telegram_session') {
          this.lastTelegramMsgID = resp.data.offset_id;
        }

        if (msgsCount) {
          this.scrollMsgToBottom();
          this.updateTab(msgsCount);
          this.lastTelegramMsgID =
            resp.data.messages[0].message_id || resp.data.messages[0].id;
        }
      }
    },
    scrollMsgToBottom(lastScrolledMsgId) {
      // для телеграм-режима только скролл вниз
      // if (this.id) {
      //   this.$nextTick(() => {
      //     const msgs = $(`#${this.id} .messages`);
      //     const scrollValue = lastScrolledMsgId
      //       ? msgs.find(`[data-id="${lastScrolledMsgId}"]`)[0].offsetTop
      //       : msgs[0].scrollHeight;
      //     if (this.allowedScroll) {
      //       window.scrollTo(0, document.body.scrollHeight);
      //     }
      //     msgs.animate({ scrollTop: scrollValue }, 500);
      //   });
      // }
      this.$nextTick(() => {
        const msgs = this.$refs.messages;
        if (!msgs) return;
        const cardPage = document.getElementsByClassName(
          'candidate-card__page'
        )[0];
        const scrollValue = lastScrolledMsgId
          ? this.$refs.message.find(`[data-id="${lastScrolledMsgId}"]`)[0]
              .offsetTop
          : msgs.scrollHeight;

        cardPage.scrollTo({
          top: cardPage.scrollHeight,
          behavior: 'smooth'
        });
        msgs.scrollTo({
          top: scrollValue
        });
      });
    },

    sendMsg() {
      // отправка нового сообщ-я доступна, если введен текст или добавлен файл
      // Максимальный размер файла - 30 мб
      setTimeout(() => {
        if (this.newMessage && this.newMessage.trim()) {
          this.templateLoader = true;
          let message = this.formatHtml(this.newMessage);
          message = message.replaceAll('<p>&nbsp;</p>', '\n');
          message = message.replaceAll('</p><p>', '\n');
          message = message.replaceAll('</p>', '\n');
          message = message.replaceAll('<br>', '\n');
          message = message.replaceAll('</li><li>', '\n');
          message = message.replace(/<\/?[^>]+(>|$)/g, '');
          message = message.replaceAll('&nbsp;', ' ');

          const defaultParams = {
            module: this.telegramModule,
            action: 'send_telegram_message',
            user_id: this.userId,
            parent_id: this.id,
            message: message
          };
          // const form = document.getElementById('msg-form-' + this.id);
          let formData = new FormData();

          for (let key in defaultParams) {
            formData.set(key, defaultParams[key]);
          }
          // formData.set('msg', this.newMessage);

          if (this.uploaded_files.length) {
            this.uploaded_files.forEach(file => {
              const { raw: blob, name } = file;
              formData.set('file', blob, name);
            });
          }

          postController({ options: formData })
            .then(resp => {
              const errors = resp.data
                ? resp.data.error || resp.data.errors
                : null;

              this.newMessage = '';
              this.model = '';
              this.fieldValue = [];

              if (errors && errors.length) {
                this.showErrorMessage(errors);
              }
            })
            .catch(err =>
              this.catchError(
                err,
                'Возникла ошибка при отправке нового сообщения',
                'send telegram message'
              )
            )
            .finally(() => {
              this.templateLoader = false;
            });
        }
      }, 500);
    },
    checkTelegramMessages() {
      this.subscriber = setInterval(async () => {
        if (!this.allowCreateMessage) {
          clearInterval(this.subscriber);
        }

        try {
          const action = 'check_new_telegram_messages';
          const resp = await getController({
            params: {
              module: this.telegramModule,
              action,
              user_id: this.userId,
              candidate_id: this.id,
              offset_id: this.lastTelegramMsgID
            }
          });

          const errors = resp?.data
            ? resp.data.error || resp.data.errors
            : null;
          if (errors) {
            this.showErrorMessage(errors);
          } else if (resp) {
            this.processMessageData(resp, action);
          } else if (!this.auth) {
            clearInterval(this.subscriber);
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка при получении новых сообщений Telegram',
            'check new telegram messages'
          );
        }
      }, 10000); // временно на 10 с
    },
    handleScroll(e) {
      if (e.target.scrollTop == 0 && !this.endPage) {
        this.visibleLoader = true;
        this.getCommunications();
      }
    },
    showAuthForm() {
      if (!this.requestSent) {
        this.requestSent = true;

        getController({
          url: `index.php?module=Users&action=getFieldsForModule&fields[]=user_name&id=${this.userId}&to_pdf=true`
        })
          .then(resp => {
            if (resp.data && resp.data.length) {
              this.sessionId = `${resp.data[0].value}_${Date.now()}`;
              this.visibleAuthForm = true;
            }
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при получении логина пользователя для сессии телеграм',
              'get user login'
            )
          )
          .finally(() => (this.requestSent = false));
      }
    },
    deleteFile(file, index) {
      this.uploaded_files.splice(index, 1);
    },
    updateEmails() {
      // проверка новых емейлов
      getController({
        params: {
          module: 'Communications',
          action: 'check_new_emails',
          user_id: this.userId,
          candidate_id: this.id,
          offset_id: this.lastEmailMsgID,
          to_pdf: true
        }
      })
        .then(resp => {
          if (resp.data.result) {
            if (resp.data.result.length == 1 && resp.data.result[0].id == null)
              return;
            this.processMessageData(resp, 'check_new_emails');
          } else {
            throw new Error(resp.data.error || resp.data.errors);
          }
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при получении новых email-сообщений',
            'new email messages load'
          )
        );
    }
  },
  watch: {
    allowCreateMessage: function () {
      if (this.allowCreateMessage) {
        this.checkTelegramMessages();
      }
    },
    'communications.length': function () {
      // корректировка отступов враппера при наличии скроллбара
      // if (this.id) {
      //   this.$nextTick(() => {
      //     const msgs = $(`#${this.id} .messages`);
      //     this.visibleScrollbar = msgs[0]
      //       ? msgs[0].offsetHeight < msgs[0].scrollHeight
      //       : false;
      //   });
      // }
      this.$nextTick(() => {
        const msgs = this.$refs.messages;
        this.visibleScrollbar = msgs
          ? msgs.offsetHeight < msgs.scrollHeight
          : false;
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.subscriber);
    this.subscriber = null;
  },
  components: {
    Message,
    BlockedIcon,
    Icon,
    AuthDialog,
    Button,
    DocumentRow,
    Editor,
    Dropdown,
    Tooltip
  }
};
</script>
<style lang="scss">
.communication-tab {
  .el-dialog .el-dialog__body {
    scrollbar-width: none !important;
  }
}

.el-message.el-message--telegram {
  z-index: 3020 !important;
}

.el-tabs__item {
  &.no-msg:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-color: inherit;
    border: 1.3px solid $green-600;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 8px;
  }

  &.has-msg:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-color: $green-600;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 8px;
  }
}
</style>

<style lang="scss" scoped>
.communications {
  background: $white;
  padding: 16px 24px;
  border: 1px solid #e9edf2;

  &-control {
    background-color: $black-10;

    &__btns {
      position: relative;
      background-color: $white;
      // box-shadow: 0px -3px 9px rgba(0, 0, 0, 0.04);
      z-index: 2;
    }
  }
}

.messages {
  // padding-top: 20px;
  height: 680px;
  overflow-x: hidden;
  overflow-y: auto;
  // margin-right: -20px;
  // scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 12px;
    background-color: $blue-20;
    border-radius: 4px;
  }
}

.communication-inputbox {
  padding-top: 8px;
  display: inline-flex;
  width: 100%;
}

.email-button {
  align-self: flex-end;
  -ms-grid-row-align: flex-end;
}

.message-area {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 8px 24px 24px;
  align-items: flex-start;

  .select-messengers {
    justify-content: center;
    align-self: flex-end;
    -ms-grid-row-align: flex-end;
  }

  &__input {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    div {
      width: 100%;
      display: flex;
      gap: 8px;
    }

    .template-button:not(:hover) {
      outline: 1px solid grey;
    }

    .message-area__textarea {
      min-height: 40px !important;
      align-self: center;
      -ms-grid-row-align: center;
      width: 100%;

      & ::v-deep .el-textarea__inner {
        min-height: 40px;
        padding: 8px 12px !important;
        line-height: 24px;
        max-height: 446px;
        -ms-overflow-style: none;
      }
    }
  }
}

.start-dialog-btn,
.check-dialog-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  font-size: 16px;
  height: 40px;
  border-radius: 4px;
  width: 455px; //455
  padding: 0 16px;
  width: 100%;
  border: none;

  svg {
    margin-right: 10px;
  }
}

.start-dialog-btn {
  background: $black-170;
}

.check-dialog-btn {
  background: $yellow-90;
}

.upload-list {
  position: relative;
  background-color: $white;
  width: 455px;
  margin: 0 auto;
}
</style>
